<template>
  <div class="error">
    <h1>{{ this.msg }}</h1>
  </div>
</template>

<script>
// import Home from './views/Home.vue';

export default {
  props: {
    msg: String,
  },
};
</script>

<style scoped lang="scss">
.error {
  color: red;
  margin: 40px;
}
</style>
